import React, { useEffect, useState } from 'react';

import Portal from 'common/common/Portal';
import delayer from 'common/util/delayer';

interface SelectPortalProps {
  children: React.ReactNode;
  align?: 'start' | 'center' | 'end';
  position?: 'top' | 'bottom';
  optionsMaxWidth?: string;
  className?: string;
  triggerRef: React.RefObject<HTMLDivElement>;
}

const SelectPortal = ({
  children,
  align = 'start',
  position = 'bottom',
  optionsMaxWidth,
  className,
  triggerRef,
}: SelectPortalProps) => {
  const [triggerWidth, setTriggerWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    const updateTriggerWidth = () => {
      if (triggerRef.current) {
        setTriggerWidth(triggerRef.current.offsetWidth);
      }
    };

    updateTriggerWidth();

    const debouncedResizeHandler = new delayer(updateTriggerWidth, 100);
    const handleResize = () => debouncedResizeHandler.callAfterDelay();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      debouncedResizeHandler.cancel();
    };
  }, [triggerRef]);

  const dropdownWidth = optionsMaxWidth || (triggerWidth ? `${triggerWidth}px` : '100%');

  return (
    <div className={className}>
      <Portal align={align} position={position} relativeToRef={triggerRef}>
        <div style={{ width: dropdownWidth }}>{children}</div>
      </Portal>
    </div>
  );
};

export default SelectPortal;
